import type { Firebase } from '@shared/firebase'
import { hc } from 'hono/client'
import type { FrontendsApi } from '../../../../../cloud/functions/api/frontends'

export const getApi = async (app: Firebase) => {
    const authToken = await app.auth!().currentUser?.getIdToken()
    if (!authToken) throw new Error('No auth token')
    return hc<FrontendsApi>('/', { headers: { Authorization: 'Bearer ' + authToken } }).api.frontends
}
